import { createBrowserRouter } from 'react-router';

import { AppProvider } from './components/AppProvider';
import { GlobalErrorFallback } from './components/GlobalErrorFallback';
import { Loading } from './components/Loading';
import { RootRedirect } from './components/redirect/RootRedirect';
import { authRoutes, cipAuthRoute } from './routes/auth';
import { authenticatedRoutes } from './routes/authenticated';
import { integrationsOAuthRoutes } from './routes/integrations';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppProvider />,
    errorElement: <GlobalErrorFallback />,
    HydrateFallback: () => <Loading />,
    children: [
      {
        index: true,
        element: <RootRedirect />,
      },

      {
        path: ':pharmacyId',
        children: [
          // OAuth popup callbacks (no auth guard: only postMessage + close)
          ...integrationsOAuthRoutes,

          // Authenticated routes
          authenticatedRoutes,

          // Auth routes
          authRoutes,
        ],
      },

      // login/cip is route that not start with :pharmacyId
      cipAuthRoute,
    ],
  },
]);
